import {useParams} from "react-router";
import {useCurrentRouteMeta} from "./useCurrentRouteMeta";

export const useId = () => {
  const params = useParams();

  const routeMeta = useCurrentRouteMeta();

  if (!routeMeta) {
    return {paramKey: null, id: null};
  }

  const matches = routeMeta.path.match(/:(\w+)/g);
  const paramsKeys = matches ? matches.map(param => param.slice(1)) : [];

  if (paramsKeys?.length == 0) {
    return {paramKey: null, id: null};
  }

  const lastKey = paramsKeys[paramsKeys.length - 1];

  return params[lastKey];
}